import React, { useEffect } from "react";
import RestaurantEditComp from "../Components/RestaurantEdit/RestaurantEdit";
const RestaurantEdit = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <RestaurantEditComp />;
};

export default RestaurantEdit;
